export const isTestEnvironment = () => process.env.NODE_ENV === 'test'

export const delay = (delay: number) =>
  new Promise<void>(resolve => setTimeout(() => resolve(), delay))

export { createLabraRender, createLabraRenderV4 } from './testing/renderer'
export type {
  LabraWrappers,
  CreateLabraRenderConfig,
  LabraRenderOptions,
} from './testing/renderer'
